export interface GetAnimalManureTransportResponse {
  receivedVdmTransports: VdmTransportResponse[];
  dispatchedVdmTransports: VdmTransportResponse[];
}

export interface VdmTransportResponse {
  status: number;
  loadDate: string;
  unloadDate: string;
  supplier: string;
  transporter: string;
  receiver: string;
  manures: ManureResponse[];
  amountInTon: number;
  phosphateInKg: number;
  nitrogenInKg: number;
  phosphateContent: number;
  nitrogenContent: number;
}

export interface ManureResponse {
  code: string;
  percentage: number;
  linkedCropAidId: number;
  isUnlinked: boolean;
}

export enum VDMTransportStatus {
  Accepted = 10,
  InProgress = 45,
  Expired = 90,
  Invalid = 0,
}

export interface FertilizerTableRow {
  rowIndex: number;
  fertilizerId: number;
  fertilizerName: string;
  comment: string;
  periodId: number;
  soilTypeId: number;
  quantity: number;
  nitrogen: number;
  phosphate: number;
  manureCode: number;
}
